import { render, staticRenderFns } from "./BypassTPh.vue?vue&type=template&id=35c93a6d&scoped=true"
import script from "./BypassTPh.vue?vue&type=script&lang=js"
export * from "./BypassTPh.vue?vue&type=script&lang=js"
import style0 from "./BypassTPh.vue?vue&type=style&index=0&id=35c93a6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c93a6d",
  null
  
)

export default component.exports